import { Link } from '@tanstack/react-router';

import { Badge, BadgeProps, Skeleton } from '@optiro/ui';

import useProject from '@/hooks/projects/useProject';
import { Project } from '@/types/types';

const ProjectBadge = ({
  projectId,
  withAnchor = false,
  size,
}: {
  projectId: Project['id'];
  withAnchor?: boolean;
  size: BadgeProps['size'];
}) => {
  const { data: project, isLoading } = useProject(projectId);

  if (isLoading) {
    return <Skeleton height={18} width={100} radius={size} />;
  }

  if (!project) {
    return null;
  }

  if (withAnchor) {
    return (
      <Link
        to={'/app/projects/$projectId'}
        params={{ projectId: String(project.id) }}
        style={{ lineHeight: 0 }}
        search={{ tab: '' }}
      >
        <Badge
          color="orange"
          variant="light"
          style={{
            cursor: 'pointer',
          }}
          size={size}
        >
          {project.name}
        </Badge>
      </Link>
    );
  }

  return (
    <Badge color="orange" variant="light" size={size}>
      {project.name}
    </Badge>
  );
};

export { ProjectBadge };
